export default __webpack_public_path__ + "static/media/kitchen5-afterE-480w.bbeb6fcc.avif";